import { useTranslation } from 'react-i18next';
import { useCountDown } from '@wbk/hooks';
import { Typography } from '@wbk/ui';
import { WebsiteConfig } from '@wbk/contentful/api';

type Props = {
  config: WebsiteConfig;
};
const Timer = ({ config }: Props) => {
  const { t } = useTranslation(['common']);
  const now = new Date().getTime() / 1000;
  const targetDate = config.header.bottomNavigationCollection.items[0].label
    ? new Date(config.header.bottomNavigationCollection.items[0].label).getTime() / 1000
    : new Date().getTime() / 1000;

  const { timer } = useCountDown({ initialSeconds: targetDate - now, id: 'header-timer' });
  if (targetDate <= now) return null;
  return (
    <div
      className='timer-border flex items-center gap-2 rounded-full px-4 py-2 lg:gap-4 xl:py-3'
      style={{ background: '#00000030', backdropFilter: 'blur(5px)' }}
    >
      <div className='flex flex-col items-center'>
        <Typography as='span' className='!text-body-XS xl:!text-body-M font-semibold leading-none'>
          {timer.days}
        </Typography>
        <span className='text xl:text-body-XXS text-[9px] text-white/50'>{t('common:days')}</span>
      </div>
      <div className='font-semibold'>:</div>
      <div className='flex flex-col items-center'>
        <Typography as='span' className='!text-body-XS xl:!text-body-M font-semibold leading-none'>
          {timer.hours}
        </Typography>
        <span className='xl:text-body-XXS text-[9px] text-white/50'>{t('common:hours')}</span>
      </div>
      <div className='font-semibold'>:</div>
      <div className='flex flex-col items-center'>
        <Typography as='span' className='!text-body-XS xl:!text-body-M font-semibold leading-none'>
          {timer.minutes}
        </Typography>
        <span className='xl:text-body-XXS text-[9px] text-white/50'>{t('common:minutes')}</span>
      </div>
    </div>
  );
};

export default Timer;
